module.exports = __webpack_public_path__ + "img/loan_activity_content_bg.503be2f5.png";